import Cookies from 'js-cookie'
export default {
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  SET_PAGE_LOADING: (state, status) => {
    state.pageLoading = status
  },
  SET_FULLSCREEN_LOADING: (state, status) => {
    state.fullscreenLoading = status
  },
  SET_CONFIGS: (state, data) => {
    state.configs = data
  },
}
